module.exports = __webpack_public_path__ + "static/media/chubb-claims-block-vehicle.a5335ec4.png";